import { useQuery } from '@tanstack/react-query';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { fetchAccountInformation } from 'modules/authentication/helpers/account';
import { IS_NEW_USER_QUERY_PARAM } from 'modules/authentication/helpers/constants';
import { emitAuthEvent } from 'modules/authentication/helpers/signIn';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuthStore from '~/authentication/store';

const enableAuthCheck = (pathname: string): boolean => {
  return !pathname.includes('personalized-offer');
};

const useOAuthEventCheck = (searchString: string) => {
  const navigate = useLocalizedNavigate();
  useEffect(() => {
    const searchParams = new URLSearchParams(searchString);
    if (searchParams.has(IS_NEW_USER_QUERY_PARAM)) {
      const isNewUser = searchParams.get(IS_NEW_USER_QUERY_PARAM) === '1';
      const provider = searchParams.get('provider') || 'unknown';
      searchParams.delete(IS_NEW_USER_QUERY_PARAM);
      searchParams.delete('provider');
      const newSearchParams = searchParams.toString();
      emitAuthEvent(isNewUser, 'oauth', provider);
      navigate(
        {
          search: newSearchParams ? `?${newSearchParams}` : '',
        },
        { replace: true },
      );
    }
  }, [searchString, navigate]);
};

export const AuthCheck = () => {
  const location = useLocation();
  useOAuthEventCheck(location.search);
  useQuery({
    queryFn: () =>
      fetchAccountInformation(useAuthStore.getState(), { silent: true }),
    queryKey: ['auth'],
    enabled: enableAuthCheck(location.pathname),
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return null;
};
